import { Validation } from "commons/enum/validation";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import {
  createCustomerDependentPagedAutoCompleteMetaData,
  createDomainPagedAutoCompleteMetaData,
} from "commons/ultilities/dynamic-form/auto-complete/providers/schema-meta-data-helpers";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { numberNanable } from "commons/ultilities/validation";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import { IAddOrder, IUpdateOrder } from "mobx-stores/_models/orders/order";
import {
  IUpdateStatus,
  IUpdateUnitPrice,
} from "mobx-stores/_models/orders/order-item";
import { date, number, string } from "yup";
export const getAddOrderFormSchema = (
  form?: IForm,
): ObjectSchemaType<IAddOrder> => {
  const resolveCustomerId = () => form?.getControl("customerId").value ?? null;

  return {
    poDate: {
      gridSize: 6,
      label: "Ngày PO",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    poNumber: {
      gridSize: 6,
      label: "Số PO",
      type: InputType.text,
      validattionYupSchema: string().required().max(64),
    },
    customerId: {
      type: InputType.autoComplete,
      gridSize: 12,
      label: "Tên giao dịch",
      validattionYupSchema: string().required(),
      metaData: createDomainPagedAutoCompleteMetaData("customer"),
    },
    items: {
      label: "Chi tiết đơn hàng",
      type: InputType.array,
      arraySchema: {
        productId: {
          label: "Mặt hàng",
          gridSize: 2,
          type: InputType.autoComplete,
          validattionYupSchema: string().required(),
          metaData: createCustomerDependentPagedAutoCompleteMetaData(
            "product",
            resolveCustomerId,
          ),
          defaultValue: "",
        },
        deliveryDate: {
          gridSize: 1.5,
          label: "Ngày giao",
          type: InputType.datePicker,
          validattionYupSchema: date().required(),
          defaultValue: dateTimeToUTCString(dayjs()),
        },
        unitPrice: {
          gridSize: 1,
          label: "Đơn giá",
          type: InputType.number,
          validattionYupSchema: number()
            .required()
            .min(0)
            .max(Validation.maxInt),
          defaultValue: undefined,
        },
        quantityUpper: {
          gridSize: 1,
          label: "SL đặt - trên",
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: undefined,
        },
        quantityStandard: {
          gridSize: 1,
          label: "SL đặt - chuẩn",
          type: InputType.number,
          validattionYupSchema: number()
            .required()
            .min(0)
            .max(Validation.maxInt),
          defaultValue: undefined,
        },
        quantityLower: {
          gridSize: 1,
          label: "SL đặt - dưới",
          type: InputType.number,
          validattionYupSchema: numberNanable(),
          defaultValue: undefined,
        },
        isCompensating: {
          gridSize: 1.5,
          label: "Bù hàng",
          type: InputType.checkbox,
          defaultValue: false,
        },
        compensatingQuantity: {
          gridSize: 1,
          label: "SL bù",
          type: InputType.number,
          disabled: true,
          defaultValue: undefined,
        },
        compensatingReason: {
          gridSize: 2,
          label: "Lý do bù",
          type: InputType.text,
          validattionYupSchema: string().max(512),
          metaData: {
            rows: 3,
          },
          disabled: true,
          defaultValue: "",
        },
      },
    },
  };
};

export const getEditOrderFormSchema = (
  form?: IForm,
): ObjectSchemaType<IUpdateOrder> => {
  const schema = getAddOrderFormSchema(form);
  const updateSchema: ObjectSchemaType<IUpdateOrder> = cloneDeep(schema);
  updateSchema.id = {
    type: InputType.none,
  };
  updateSchema.items.arraySchema.id = {
    type: InputType.none,
  };
  return updateSchema;
};

export const getUpdateStatusSchema = (): ObjectSchemaType<IUpdateStatus> => ({
  id: {
    type: InputType.none,
  },
  statusId: {
    type: InputType.select,
    gridSize: 12,
    label: "Trạng thái đơn hàng",
    validattionYupSchema: string().required(),
  },
  deliveredQuantity: {
    type: InputType.number,
    gridSize: 12,
    label: "Tổng số lượng đã giao",
    validattionYupSchema: number().required(),
  },
});

export const getUpdateUnitPriceSchema =
  (): ObjectSchemaType<IUpdateUnitPrice> => ({
    id: {
      type: InputType.none,
    },
    unitPrice: {
      gridSize: 12,
      label: "Đơn giá",
      type: InputType.number,
      validattionYupSchema: number().required().min(0).max(Validation.maxInt),
    },
  });
